import * as React from 'react'
import styled, { css } from 'styled-components'
import { Close } from 'svgIcons'
import Button from '@app.components/Button'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'

interface DeleteNewsItemScrapModalProps extends IFModalProps {
  totalCount?: number
  onConfirm?: () => void
}

const DeleteNewsItemScrapModal: React.FC<DeleteNewsItemScrapModalProps> = ({
  onClose,
  onConfirm,
  totalCount,
  ...props
}) => {
  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper>
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <div className="modal-sub-title">
          잠깐, <span>스크랩한 {totalCount}건의 채널소식</span> 을 모두
          삭제하실건가요?
        </div>
        <div className="btn-list">
          <Button color="grey" className="btn cancle" onClick={onClose}>
            아니요
          </Button>
          <Button className="btn" onClick={onConfirm}>
            삭제하기
          </Button>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default DeleteNewsItemScrapModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 450px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;

  .close-btn {
    align-self: flex-end;
    color: #999999;
    cursor: pointer;
  }
  .modal-sub-title {
    font-size: 18px;
    margin: 20px 0 31px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    span {
      color: #01a0ff;
    }
  }
  .btn-list {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    width: 100%;
    .btn {
      width: 100%;
      font-size: 16px;
      padding: 13px 30px;
      &.cancle {
        background-color: #bbbbbb;
      }
    }
  }

  ${({ theme }) =>
    theme.isMobile &&
    css`
      max-width: 350px;
    `}
`
